import { Link } from 'react-router-dom';
import { allTags } from '@/mocks/manga';

const tagColors = [
  'bg-primary-100 text-primary-700 hover:bg-primary-500 hover:text-background-50',
  'bg-accent-100 text-accent-800 hover:bg-accent-500 hover:text-background-50',
  'bg-secondary-100 text-secondary-800 hover:bg-secondary-500 hover:text-background-50',
];

function TagsSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16" aria-labelledby="tags-title">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-primary-600">标签找书</span>
          <h2 id="tags-title" className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            热门标签找书
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">
            按漫画标签找书，一键直达你感兴趣的内容方向
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {allTags.map((tag, i) => (
            <Link
              key={tag}
              to={`/category?tag=${encodeURIComponent(tag)}`}
              className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${tagColors[i % tagColors.length]}`}
              title={`${tag} 标签漫画`}
            >
              <i className="ri-price-tag-3-line text-xs"></i>
              {tag}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TagsSection;